<template>
  <section>
    <div class="container">
      <custom-title-block :title="title" class="grc" />
      <grc-types-content :types="GRCs" />
      <custom-button @click="openLink">
        <span>{{ button }}</span>
      </custom-button>
    </div>
  </section>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import CustomButton from "@/components/UI/CustomButton.vue";
import GrcTypesContent from "@/components/main/GRCTypes/modules/GRCTypesContent.vue";

export default {
  name: "grc-types",
  components: {
    GrcTypesContent,
    CustomButton,
    CustomTitleBlock,
  },
  data() {
    return {
      title: "ТИПИ НАЗЕМНИХ РОБОТИЗОВАНИХ КОМПЛЕКСІВ (НРК)",
      button: "Переглянути відео про НРК",
      GRCs: [
        {
          id: 1,
          title: "Логістика та евакуація",
          description:
            "Доставляють боєприпаси, провізію та інше забезпечення на передову, " +
            "а також безпечно вивозять поранених із поля бою",
          imgs: ["1_1", "1_2"],
        },
        {
          id: 2,
          title: "Інженерна підтримка",
          description: "Швидко та ефективно встановлюють або знешкоджують міни",
          imgs: ["2"],
        },
        {
          id: 3,
          title: "Вогнева підтримка",
          description: "Знищують ворожі цілі",
          imgs: ["3_1", "3_2"],
        },
      ],
    };
  },
  methods: {
    openLink() {
      window.open("https://youtu.be/AxXcn1AJqsI", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  font-family: "UAF Sans H", serif;

  @media (max-width: 767px) {
    font-size: 13px !important;
  }
}
</style>
